import { Controller } from "@hotwired/stimulus";
import { patch } from "@rails/request.js";
import Sortable from 'sortablejs';

export default class extends Controller {
  static values = {
    dragHandle: String,
    url: String,
    scope: String
  }

  connect() {
    const url = this.urlValue;
    const elementScope = this.scopeValue;
  
    this.sortable = Sortable.create(this.element, {
      handle: this.dragHandleValue,
      onEnd: async function (evt) {
        const itemEl = evt.item;
        const elementId = itemEl.getAttribute("data-element-id");
        const parsedUrl = url.replace("ELEMENT_ID", elementId);
        const newPosition = evt.newIndex + 1;

        await patch(parsedUrl, {
          body: JSON.stringify({ [elementScope]: { position: newPosition } }),
        });
      },
    });
  }
}
